import React, { useState, useEffect } from 'react'
import { Text, Flex, FormControl, Input, Button, useToast, Textarea } from '@chakra-ui/react'
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function FormContact() {

    const { t } = useTranslation();

    const toast = useToast();
    const [formErrors, setFormErrors] = useState({});
    const [formData, setFormData] = useState({
        name: '',
        company: '',
        email: '',
        service: '',
        message: '',
        website: ''
    });

    const clearFilters = () => {
        setFormData({
            name: '',
            company: '',
            email: '',
            service: '',
            message: '',
            website: ''
        });
    }

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (id) => {

        if (formData.website) {
            console.warn("Bot detected");
            return;
        }

        try {
            const response = await axios.post(`/sendForm`, formData);

            toast({
                title: 'Petition send succesfully',
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
            clearFilters();
            setFormErrors({});
        } catch (error) {
            toast({
                title: "Error sending the petition",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            console.error('Error updating the ', error);
            setFormErrors(error.response.data.errors);
        }
    };

    return (
        <Flex

            flexDirection={'column'}
            p={{ base: '8%', md: '3%' }}
            w={{ base: '100%', md: '70%', lg: '45%' }}
            bg={'white'} borderRadius={'15px'}
            mb={'10%'}
        >

            <FormControl display="none">
                <Input
                    type="text"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    autoComplete="off"
                    tabIndex="-1"
                />
            </FormControl>

            <Flex flexDirection={{ base: 'column', md: 'row' }} gap={7} marginTop={'2%'} >
                <FormControl>
                    <Text color={'#929292'} fontFamily={'Avenir LT Pro'} fontSize={'150%'}>{t("formlabel1")}</Text>
                    <Input
                        type="text"
                        bg={'#0000001A'}
                        borderBottom="2px solid white"
                        borderRadius="0"
                        color="#929292"
                        _placeholder={{ color: 'whiteAlpha.700' }}
                        _focus={{ borderBottom: '2px solid white' }}
                        name='name'
                        onChange={handleChange}
                        value={formData.name}
                    />
                </FormControl>
                <FormControl>
                    <Text color={'#929292'} fontFamily={'Avenir LT Pro'} fontSize={'150%'}>{t("formlabel2")}</Text>
                    <Input
                        type="text"

                        borderBottom="2px solid white"
                        borderRadius="0"
                        color="#929292"
                        bg={'#0000001A'}
                        _placeholder={{ color: 'whiteAlpha.700' }}
                        _focus={{ borderBottom: '2px solid white' }}
                        name='company'
                        onChange={handleChange}
                        value={formData.company}
                    />
                </FormControl>
            </Flex>

            <Flex flexDirection={{ base: 'column', md: 'row' }} gap={7}>
                <FormControl>
                    <Text color={'#929292'} fontFamily={'Avenir LT Pro'} fontSize={'150%'} marginTop={'2%'}>{t("formlabel3")}</Text>
                    <Input
                        type="text"
                        borderBottom="2px solid white"
                        borderRadius="0"
                        color="#929292"
                        _placeholder={{ color: 'whiteAlpha.700' }}
                        _focus={{ borderBottom: '2px solid white' }}
                        bg={'#0000001A'}
                        name='email'
                        onChange={handleChange}
                        value={formData.email}
                    />
                </FormControl>
                <FormControl>
                    <Text color="#929292" fontFamily={'Avenir LT Pro'} fontSize={'150%'} marginTop={'2%'}>{t("formlabel4")}</Text>
                    <Input
                        type="text"
                        borderBottom="2px solid white"
                        borderRadius="0"
                        color="#929292"
                        _placeholder={{ color: 'whiteAlpha.700' }}
                        _focus={{ borderBottom: '2px solid white' }}
                        name='service'
                        bg={'#0000001A'}
                        onChange={handleChange}
                        value={formData.service}
                    />
                </FormControl>

            </Flex>

            <FormControl>
                <Text color="#929292" fontFamily={'Avenir LT Pro'} fontSize={'150%'} marginTop={'2%'}>{t("formlabel5")}</Text>
                <Textarea
                    type="text"
                    borderBottom="2px solid white"
                    borderRadius="0"
                    color="#929292"
                    _placeholder={{ color: 'whiteAlpha.700' }}
                    _focus={{ borderBottom: '2px solid white' }}
                    name='message'
                    bg={'#0000001A'}
                    onChange={handleChange}
                    value={formData.message}
                />
            </FormControl>


            <Flex justifyContent={'left'} >
                <Button
                    fontSize="130%"
                    color="white"
                    borderRadius="30px"
                    p={{ base: '5%', md: '2%' }}
                    fontFamily="Avenir LT Pro"
                    fontWeight="medium"
                    bg={'#AE8245'}
                    _hover={{ bg: '#808080' }}
                    marginTop={{ base: '20%', md: '5%' }}
                    onClick={handleSubmit}
                >
                    {t("quote")}
                </Button>
            </Flex>
        </Flex>


    )
}

export default FormContact